import {TranslationObject} from '@colonist/i18n'
import {clientI18n} from '../../../../shared/scripts/ClientI18n'
import {createDivIn, setElementOnClick} from '../../../../shared/scripts/ui_utils/DomUtils'
import {UIMFullscreenPageView} from '../../ui_page/UIMFullscreenPageView'
import {uiManager} from '../../EntryMobile'
import {AudioManager, AudioType} from '@colonist/audio'

export interface RoomTab {
    title: TranslationObject
    containerClass: string
    isActive: boolean
    id: number
}

export class UIMFullscreenTabView extends UIMFullscreenPageView {
    private readonly tabs: HTMLDivElement[] = []
    private readonly tabProperties: RoomTab[]
    private readonly containers: HTMLDivElement[] = []
    private readonly buttonText?: TranslationObject | undefined
    private readonly onTabChange?: ((tabIdx: number) => void) | undefined

    private continueButton: HTMLDivElement | undefined
    private activeTabIdx: number

    constructor(title: TranslationObject, tabProperties: RoomTab[], buttonText?: TranslationObject, onTabChange?: (tabIdx: number) => void) {
        super(title, 'room', () => uiManager.createRoomController.onExitRoom())
        this.tabProperties = tabProperties
        this.buttonText = buttonText
        this.shouldHideOnBackButton = false
        this.onTabChange = onTabChange
        this.build(true)
    }

    buildView(): void {
        const tabContainer = createDivIn(this.body, 'm-tabs-container')

        this.tabProperties.map((tabInfo: RoomTab, idx: number) => {
            const tab = createDivIn(tabContainer, 'm-tab')
            tab.innerText = clientI18n.t(tabInfo.title.key, tabInfo.title.options)
            if(tabInfo.isActive) tab.classList.add('m-tab-active')

            const container = createDivIn(this.body, tabInfo.containerClass)
            if(!tabInfo.isActive) container.classList.toggle('hidden')

            this.tabs.push(tab)
            this.containers.push(container)

            setElementOnClick(tab, () => this.updateActiveTabToIndex(idx))

            if(tabInfo.isActive) this.activeTabIdx = idx
        })

        if(this.buttonText) this.createButtons()
    }

    private createButtons() {
        this.continueButton = createDivIn(this.body, 'm-continue-button')
        this.continueButton.innerText = clientI18n.t('strings:game.endGame.footer.continue')
    }

    setOnClickContinueButton(callback: (isLastPage: boolean) => void) {
        if(this.continueButton == undefined) return
        setElementOnClick(this.continueButton, () => {
            AudioManager.play(AudioType.Click)

            let isLastPage = false
            let updatedTabIdx = this.activeTabIdx + 1
            if(updatedTabIdx >= this.tabs.length) {
                updatedTabIdx = 0
                isLastPage = true
            }
            callback(isLastPage)
            this.updateActiveTabToIndex(updatedTabIdx)
        })
    }

    updateActiveTabToIndex(idx: number, playSound: boolean = false): void {
        this.tabs[this.activeTabIdx].classList.remove('m-tab-active')
        this.containers[this.activeTabIdx].classList.toggle('hidden')

        const tab = this.tabs[idx]
        const container = this.containers[idx]
        tab.classList.add('m-tab-active')
        container.classList.toggle('hidden')
        if(playSound) AudioManager.play(AudioType.Click)
        this.activeTabIdx = idx
        if(this.onTabChange) this.onTabChange(this.activeTabIdx)
        this.updateContinueButton()
    }

    private updateContinueButton() {
        if(!this.continueButton) return
        if(!this.buttonText) return
        const isLastTab = this.activeTabIdx == this.tabs.length - 1
        this.continueButton.className = isLastTab ? 'm-create-room-button' : 'm-continue-button'
        this.continueButton.innerText = isLastTab ? clientI18n.t(this.buttonText.key, this.buttonText?.options) : clientI18n.t('strings:game.endGame.footer.continue')
    }

    getContainerWithTabIdx(idx: number): HTMLDivElement {
        return this.containers[idx]
    }

    setTabTitle(idx: number, text: TranslationObject) {
        this.tabs[idx].innerText = clientI18n.t(text.key, text.options)
    }
}
